import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface CustomBillingAddressTooltipProps {
  openLeft: boolean
}

const CustomBillingAddressTooltip: React.FC<
  CustomBillingAddressTooltipProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        {translate(
          '${virtualCardBillingAddress} is the same as the underlying account\'s billing address. To change it for this virtual card only, select "Change Billing Address" and enter a custom address. This can only be done when creating a virtual card.',
          {
            virtualCardBillingAddress: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                {translate('Virtual card billing address')}
              </span>
            ),
          },
        )}
      </p>
    </Tooltip>
  )
}

export default CustomBillingAddressTooltip
